import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import { ReportPayload } from "type/report";

export const report = createApi({
  reducerPath: "report",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getReport: builder.mutation<any, ReportPayload>({
      query: (body) => ({
        url: `orders/orderStatsByDayMonthYear`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetReportMutation } = report;
